import {
  motion, useTransform, useScroll, useSpring
} from 'framer-motion';
import Box from '@mui/material/Box';
import Image from 'components/Image';
import Stack from '@mui/material/Stack';
import React, { useRef } from 'react';
import Typography from '@mui/material/Typography';

const TITLE = 'Take Imperfect Photos';
const SUBTITLE = 'Scribble\'s advanced computer vision algorithms will automatically remove backgrounds, straighten, and enhance your photos';

const ImperfectPhotos = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end end']
  });

  const handPosition = useTransform(scrollYProgress, [0.4, 1], [100, 0]);
  const handPositionSpring = useSpring(handPosition, { stiffness: 50, damping: 30, mass: 1 });
  const textOpacity = useTransform(scrollYProgress, [0.4, 1], [0, 1]);

  return (
    <>
      <Box className="phoneSection">
        <motion.div
          style={{
            x: handPositionSpring
          }}
        >
          <Box className="phoneBox">
            <Image
              src="/img/marketing/landing/section_imperfect/phone_hand.png"
              alt="Camera phone taking picture of artwork for Scribble"
              layout="fill"
              objectFit="contain"
            />
          </Box>
        </motion.div>
      </Box>
      <Stack className="imperfectSection" ref={ref}>
        <motion.div
          className="sectionText"
          style={{
            opacity: textOpacity
          }}
        >
          <Typography
            variant="bookPreview"
            component="h3"
          >
            {TITLE}
          </Typography>
          <Typography
            variant="bookPreview"
            component="h4"
          >
            {SUBTITLE}
          </Typography>
        </motion.div>
      </Stack>
    </>
  );
};

export default ImperfectPhotos;
